export default __webpack_public_path__ + "static/media/tramy_chat_wallpaper.2a840192.svg";